export class MapResult {

  constructor(app) {


    $('[data-role="showMoreResult"]').click(this.showNext.bind(this));
    this.moreBlocks = [];
    $('.search-results__wrap').each((index,el) => {
      this.moreBlocks.push(el);
    });
    this.showNext();
  }

  showNext(e) {
    let target = this.moreBlocks.shift();
    if(e){
      $(e.currentTarget).closest('.search-results__btn').remove();
      $(target).fadeIn(300);
    }else{
      $(target).show();
    }
    
  }

}